import { RefObject, useEffect } from 'react';

export function useIframeMessageRef(
  iframeRef: RefObject<HTMLIFrameElement>,
  handler: (data: object, event: MessageEvent) => void
): void {
  useEffect(() => {
    const iframeWindow = iframeRef.current?.contentWindow;

    const handleMessage = (event: MessageEvent): void => {
      if (event.source !== iframeWindow) return;
      handler(event.data, event);
    };

    if (iframeWindow) {
      window.addEventListener('message', handleMessage);
    }

    return (): void => {
      if (iframeWindow) {
        window.removeEventListener('message', handleMessage);
      }
    };
  }, [iframeRef, handler]);
}
